import { FC } from 'react';

import Image from './image.png';

export const AuthenticateImage: FC = () => <img src={Image} alt="authenticate" />;
